import React from 'react'

const Linkedin = (props) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 16 15.289"
    >
    <path fill={props.color} d="M16,9.373v5.916h-3.43V9.77c0-1.387-0.496-2.332-1.736-2.332c-0.949,0-1.512,0.637-1.76,1.254
    C8.984,8.912,8.96,9.22,8.96,9.527v5.762H5.53c0,0,0.046-9.348,0-10.316h3.43v1.463c-0.006,0.01-0.016,0.021-0.022,0.033H8.96V6.436
    c0.456-0.703,1.269-1.706,3.091-1.706C14.309,4.729,16,6.205,16,9.373z M1.941,0C0.768,0,0,0.77,0,1.782
    c0,0.989,0.745,1.784,1.896,1.784h0.022c1.196,0,1.94-0.795,1.94-1.784C3.836,0.77,3.115,0,1.941,0z M0.204,15.289h3.429V4.973
    H0.204V15.289z"/>
  </svg>
)

export default Linkedin


// WEBPACK FOOTER //
// ./src/components/Icons/Linkedin.js